import type { View } from "./pages.js";
import { escape as e } from "./api.js";
import { itemDetails } from "./inventory.js";
export const wearGrades = [
  "Factory New",
  "Minimal Wear",
  "Field-Tested",
  "Well-Worn",
  "Battle-Scarred",
];
const bands = [
  [0, 0.07],
  [0.07, 0.15],
  [0.15, 0.38],
  [0.38, 0.45],
  [0.45, 1],
];
export function supportedWear(c: any) {
  return bands
    .map(([a, b], i) => ({
      i,
      valid: Math.max(a, c.wearMin ?? 0) < Math.min(b, c.wearMax ?? 1),
    }))
    .filter((w) => w.valid)
    .map((w) => w.i);
}
const percent = (p: number) =>
  (p * 100).toFixed(p === 0 || p >= 0.01 ? 2 : 5) + "%";
export function crateCatalogue(v: View) {
  const tier = v.crateTier ?? 1,
    t = v.content.crateTiers.find((t: any) => t.tier === tier),
    odds = t.odds;
  const search = (v.crateSearch ?? "").toLowerCase();
  const items = odds.items.map((o: any) => ({
    ...v.content.cosmetics.find((c: any) => c.id === o.id),
    probability: o.probability,
  }));
  const selected = v.cratePreview,
    template = selected && items.find((c: any) => c.id === selected.templateId);
  const groups = (key: string) =>
    Object.entries(
      items.reduce((a: any, c: any) => {
        const k =
          key === "family"
            ? c.category === "agent"
              ? "Agents"
              : c.name
            : (c[key] ?? (c.category === "agent" ? "Agents" : "Vanilla"));
        a[k] = (a[k] ?? 0) + c.probability;
        return a;
      }, {}),
    )
      .sort((a, b) => Number(b[1]) - Number(a[1]))
      .map(([k, p]) => `<span>${e(k)} <b>${percent(Number(p))}</b></span>`)
      .join("");
  const qty = ((v.user as any).crates ?? []).filter(
    (c: any) => c.tier === tier,
  ).length;
  return `<section class="crate-catalogue"><div class="page-title"><h1>TIER ${tier} CRATE</h1><div>${qty ? `<button class="primary" data-action="open-crate" data-tier="${tier}">OPEN (${qty})</button>` : ""}<button data-action="close-crate-contents">BACK</button></div></div>
    <div class="odds-summary">${Object.entries(odds.categories)
      .map(
        ([k, p]) =>
          `<span>${e(k.toUpperCase())}<b>${percent(Number(p))}</b></span>`,
      )
      .join("")}</div>
    <p class="preview-disclaimer">All odds are per crate, rounded for display. Preview wear and seeds are examples; each drop is rolled independently.</p>
    <details><summary>Family and finish odds</summary><div class="odds-summary">${groups("family")}</div><div class="odds-summary">${groups("finishName")}</div></details>
    <div class="filters"><input id="crate-search" type="search" aria-label="Search crate contents" placeholder="Search items or finishes" value="${e(v.crateSearch ?? "")}"></div>
    <div class="catalogue-layout"><div class="catalogue-list">${items
      .filter((c: any) =>
        (c.name + " " + (c.finishName ?? "")).toLowerCase().includes(search),
      )
      .map(
        (c: any) =>
          `<button data-action="preview-content" data-id="${e(c.id)}" class="${template?.id === c.id ? "selected" : ""}">${c.image ? `<img loading="lazy" src="${e(c.image)}" alt="">` : ""}<b>${e(c.name)}</b><small>${e(c.finishName ?? "Agent")}</small><small>${percent(c.probability)} per crate</small></button>`,
      )
      .join("")}</div>
    <div>${selected ? itemDetails(v, selected) : '<aside class="inventory-presentation"><p>Select an item to preview.</p></aside>'}${
      template && selected.wear != null
        ? `<div class="preview-options"><label>Wear<select id="preview-wear" aria-label="Preview wear">${supportedWear(
            template,
          )
            .map(
              (i) =>
                `<option value="${i}" ${i === selected.wearChoice ? "selected" : ""}>${wearGrades[i]}</option>`,
            )
            .join(
              "",
            )}</select></label><label>Example seed<select id="preview-seed" aria-label="Example seed">${[0, 1, 387, 661, 1000].map((seed) => `<option ${seed === selected.paintSeed ? "selected" : ""}>${seed}</option>`).join("")}</select></label></div>`
        : ""
    }</div></div></section>`;
}
